// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iLvs","content":"styles_content__ih2H7","footText":"styles_footText__34G-U"};